// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1mknu","large":"styles_large__1eyIE"};